import { Link } from "react-router-dom";
import { Reveal } from "@/components/Motion";
import { ScrollText, ArrowLeft } from "lucide-react";
import { BRAND } from "@/lib/brand";

const UPDATED = "June 2026";

export default function Terms() {
  return (
    <div className="max-w-[900px] mx-auto px-5 md:px-10 pt-36 pb-28 min-h-screen" data-testid="terms-page">
      <Reveal>
        <span className="mono-label text-cyan">Legal</span>
        <h1 className="font-display text-5xl md:text-6xl tracking-tight mt-4 mb-3">Terms & Conditions</h1>
        <p className="text-white/40 font-mono text-sm mb-10">Last updated: {UPDATED}</p>
      </Reveal>

      <Reveal delay={0.05}>
        <div className="glass rounded-2xl p-8 border border-white/10 mb-6 text-white/60 leading-relaxed space-y-4">
          <ScrollText className="text-cyan mb-1" size={26} />
          <p>
            These Terms & Conditions govern your use of the {BRAND.name} website and services. By purchasing, bidding,
            booking a service, or creating an account, you agree to these terms.
          </p>

          <h2 className="font-display text-2xl text-white pt-2">Orders & livestock</h2>
          <ul className="space-y-2 list-disc pl-5">
            <li>All livestock (corals & fish) are sold as living animals; availability and appearance may vary.</li>
            <li>Shipping is <b className="text-white">$50 flat</b>, <b className="text-cyan">free over $450</b>, and only ships when transit conditions are safe. See our <Link to="/policy" className="text-cyan">Shipping & DOA Policy</Link>.</li>
            <li>DOA (Dead On Arrival) claims must be submitted within <b className="text-white">3 hours</b> of delivery with photos of the specimen and box.</li>
          </ul>

          <h2 className="font-display text-2xl text-white pt-2">Auctions</h2>
          <ul className="space-y-2 list-disc pl-5">
            <li>Bids are binding commitments to purchase at the winning price. You must have an account to bid.</li>
            <li>We use proxy bidding — you set a maximum and the system bids the minimum needed on your behalf.</li>
            <li>Winners settle payment directly with {BRAND.name} and arrange shipping/pickup after the auction ends.</li>
          </ul>

          <h2 className="font-display text-2xl text-white pt-2">Service bookings & deposits</h2>
          <ul className="space-y-2 list-disc pl-5">
            <li>Deposits reserve your appointment and are applied to your final invoice.</li>
            <li>Please contact us to reschedule. Deposits for missed appointments may be non-refundable.</li>
          </ul>

          <h2 className="font-display text-2xl text-white pt-2">SMS text messages</h2>
          <p>
            By providing your mobile number you consent to receive transactional SMS from {BRAND.name} (e.g. auction
            outbid/win alerts and booking confirmations). Message frequency varies; message and data rates may apply.
            Reply <b className="text-white">STOP</b> to unsubscribe or <b className="text-white">HELP</b> for help. See our{" "}
            <Link to="/privacy" className="text-cyan">Privacy Policy</Link> for how we handle your data.
          </p>

          <h2 className="font-display text-2xl text-white pt-2">Payments</h2>
          <p>Payments are processed securely through Stripe. You agree to provide accurate billing information.</p>

          <h2 className="font-display text-2xl text-white pt-2">Contact</h2>
          <p>
            {BRAND.name} · Phone/Text: <a href={BRAND.phoneHref} className="text-cyan">{BRAND.phone}</a> ·{" "}
            <a href="mailto:gutierreztony122012@icloud.com" className="text-cyan">gutierreztony122012@icloud.com</a>
          </p>
        </div>
      </Reveal>

      <div className="flex gap-4 mt-10">
        <Link to="/" className="btn-pill inline-flex items-center gap-2"><ArrowLeft size={15} /> Back home</Link>
        <Link to="/privacy" className="btn-pill inline-flex items-center gap-2">Privacy Policy</Link>
      </div>
    </div>
  );
}
